import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class CellsTitle extends PureComponent {
  render() {
    const { children, className, ...others } = this.props;
    const cls = classNames({
      "weui-cells__title": true
    }, className);

    return <div className={ cls } { ...others }>{ children }</div>;
  }
}
